const cardItems = [
  {
    title: '深度解读：2026上半年娱乐圈五大现象级吃瓜事件复盘',
    excerpt: '从年初的顶流塌房到最近的综艺失控，我们梳理了今年上半年最具话题性的五大娱乐事件，带你回顾那些让人惊掉下巴的吃瓜瞬间。',
    tag: '深度',
    date: '07-30',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20editorial%20illustration%20with%20warm%20coral%20and%20amber%20tones%2C%20abstract%20pop%20culture%20collage%2C%20modern%20magazine%20aesthetic%2C%20clean%20layout%2C%20soft%20gradients%2C%20artistic%20composition&width=600&height=400&seq=card-img-1&orientation=landscape',
  },
  {
    title: '从综艺翻车看娱乐圈生存法则：那些年我们追过的名场面',
    excerpt: '综艺节目翻车事件频发背后，折射出娱乐圈竞争加剧的现实。我们盘点了近年来最经典的综艺翻车名场面，看看哪些让你至今难忘。',
    tag: '盘点',
    date: '07-29',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20illustration%20with%20warm%20golden%20lighting%2C%20stage%20lights%20and%20cameras%2C%20entertainment%20production%20aesthetic%2C%20editorial%20style%2C%20soft%20amber%20gradients%2C%20modern%20composition&width=600&height=400&seq=card-img-2&orientation=landscape',
  },
  {
    title: '明星恋情曝光经济学：为什么吃瓜群众越来越"专业"',
    excerpt: '明星恋情从纯八卦变成了全民参与的娱乐消费。分析吃瓜文化的变迁，探讨粉丝经济如何重塑了我们消费娱乐八卦的方式。',
    tag: '观察',
    date: '07-28',
    img: 'https://readdy.ai/api/search-image?query=Celebrity%20culture%20illustration%20with%20warm%20peach%20and%20coral%20tones%2C%20abstract%20heart%20and%20star%20motifs%2C%20editorial%20design%20aesthetic%2C%20soft%20lighting%2C%20romantic%20modern%20composition&width=600&height=400&seq=card-img-3&orientation=landscape',
  },
  {
    title: '番位之争何时休？从杀青宴冲突看娱乐圈的残酷现实',
    excerpt: '番位之争是娱乐圈永恒的话题。这次杀青宴上的冲突只是冰山一角，背后反映的是整个行业资源分配和艺人话语权的深层博弈。',
    tag: '分析',
    date: '07-27',
    img: 'https://readdy.ai/api/search-image?query=Movie%20production%20set%20illustration%20with%20warm%20theatrical%20lighting%2C%20abstract%20film%20elements%2C%20cinematic%20atmosphere%2C%20editorial%20style%2C%20coral%20and%20golden%20accents%2C%20modern%20composition&width=600&height=400&seq=card-img-4&orientation=landscape',
  },
  {
    title: '音乐抄袭鉴定指南：普通吃瓜群众如何判断"像"与"抄"',
    excerpt: '每当有新歌爆出抄袭争议，吃瓜群众总是分成两派。本文提供几个简单的判断方法，帮你从旋律、编曲、结构三个维度自己分析到底算不算抄。',
    tag: '科普',
    date: '07-26',
    img: 'https://readdy.ai/api/search-image?query=Music%20production%20studio%20illustration%20with%20warm%20amber%20lighting%2C%20abstract%20audio%20waveforms%2C%20editorial%20design%20aesthetic%2C%20soft%20gradients%2C%20modern%20minimal%20composition&width=600&height=400&seq=card-img-5&orientation=landscape',
  },
  {
    title: '代言人解约潮背后的品牌博弈：明星商业价值大洗牌',
    excerpt: '近期多个品牌与代言人解约事件引发关注。我们分析了近一年的代言数据，发现品牌选择代言人的标准正在发生根本性变化。',
    tag: '数据',
    date: '07-25',
    img: 'https://readdy.ai/api/search-image?query=Brand%20marketing%20illustration%20with%20warm%20coral%20tones%2C%20abstract%20business%20elements%2C%20editorial%20style%2C%20soft%20golden%20accents%2C%20modern%20clean%20composition%2C%20luxury%20aesthetic&width=600&height=400&seq=card-img-6&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            深度吃瓜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">不只是吃瓜，更是深度解读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-secondary-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500/90 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.excerpt}</p>
                <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-calendar-line mr-1"></i>2026-{item.date}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    <i className="ri-chat-1-line mr-1"></i>{32 - idx * 4} 评论
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}